import { render, staticRenderFns } from "./embedModal.vue?vue&type=template&id=713d0ea8&scoped=true"
import script from "./embedModal.vue?vue&type=script&lang=ts"
export * from "./embedModal.vue?vue&type=script&lang=ts"
import style0 from "./embedModal.vue?vue&type=style&index=0&id=713d0ea8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d0ea8",
  null
  
)

export default component.exports